import { cn } from '@/lib/utils'
import React from 'react'

const ChatNotificationBanner = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { variant?: 'error' | 'default' }
>(({ className, children, variant = 'default', ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex w-full items-center justify-center rounded-lg border p-4 text-sm font-[450] tracking-wide',
      variant === 'error' && 'border-error-100 bg-error-50 text-error-300',
      variant === 'default' && 'border-neutral-75 bg-neutral-25 text-neutral-500',
      className,
    )}
    {...props}
  >
    {children}
  </div>
))
ChatNotificationBanner.displayName = 'ChatNotificationBanner'

const ChatInappropriateMessage = () => (
  <ChatNotificationBanner variant='error'>
    Inappropriate query. Please rephrase your query to conform to our safety standards.
  </ChatNotificationBanner>
)

export { ChatInappropriateMessage, ChatNotificationBanner }
